import { render, staticRenderFns } from "./MpModel3dV2.vue?vue&type=template&id=c36b5ffa&scoped=true&"
import script from "./MpModel3dV2.vue?vue&type=script&lang=js&"
export * from "./MpModel3dV2.vue?vue&type=script&lang=js&"
import style0 from "./MpModel3dV2.vue?vue&type=style&index=0&id=c36b5ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b5ffa",
  null
  
)

export default component.exports